// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__18Yo4","fileDisabled":"File_fileDisabled__2Ra07"};